import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { AnalyticsFilterType } from "./analytics-filter-type";

export function makeReportFilterSchema<
  Type extends AnalyticsFilterType,
  Query extends z.core.util.EnumLike,
  Value extends z.ZodType,
>(type: Type, query: Query, value: Value) {
  return z.object({
    type: z.literal(type),
    query: createEnum(query),
    value: value.optional(),
  });
}

export type BaseReportFilter<
  Type extends AnalyticsFilterType,
  Query extends z.core.util.EnumLike,
  Value extends z.ZodType,
> = z.infer<ReturnType<typeof makeReportFilterSchema<Type, Query, Value>>>;
